import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import ActivityDetails from '@activities/components/details/activity-details/activity-details.vue';

@Component({
  name: 'bpc-public-activity-details',
  components: {
    'bpc-activity-details': ActivityDetails,
  },
})
export default class PublicActivityDetails extends Vue {
  @Prop({ type: String }) readonly alias: string;
  @Prop({ type: [String, Number] }) readonly postId: string | number;
  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
}
